var exports = {
  "ci": "TextareaInput.module__textareaContainer___OVVaNT",
  "yF": "TextareaInput.module__divider___OVVaNT",
  "Ot": "TextareaInput.module__textareaOuter___OVVaNT",
  "WJ": "TextareaInput.module__collapsibleSection___OVVaNT",
  "qp": "TextareaInput.module__inputSection___OVVaNT",
  "aq": "TextareaInput.module__textareaOuterMobile___OVVaNT",
  "AE": "TextareaInput.module__mainWrapperDense___OVVaNT",
  "bx": "TextareaInput.module__mainWrapperEditing___OVVaNT",
  "m$": "TextareaInput.module__uploadButtonColumn___OVVaNT",
  "D4": "TextareaInput.module__sideButtonPadding___OVVaNT",
  "Qh": "TextareaInput.module__plusButtonAboveBackdrop___OVVaNT",
  "Sr": "TextareaInput.module__contentAreaDense___OVVaNT",
  "h": "TextareaInput.module__contentAreaEditing___OVVaNT",
  "l7": "TextareaInput.module__buttonContainerDense___OVVaNT",
  "ae": "TextareaInput.module__buttonContainerEditing___OVVaNT",
  "ou": "TextareaInput.module__textareaOuterRow___OVVaNT",
  "o_": "TextareaInput.module__textareaOuterBare___OVVaNT",
  "nw": "TextareaInput.module__mainWrapperBare___OVVaNT",
};

module.exports = exports;
